import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function ScanBulkEdit({ ids, open, onClose, onSaved, Picker }) {
  const [customer, setCustomer] = useState(null);
  const [num, setNum] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    const body = { ids, ...(customer ? { customer_key: customer.key } : {}), ...(num.trim() ? { invoice_number: num.trim() } : {}), ...(note.trim() ? { note: note.trim() } : {}) };
    if (Object.keys(body).length === 1) return toast.error("Choose a customer or type an invoice # or note");
    setBusy(true);
    try {
      const { data } = await api.post("/scans/bulk-edit", body);
      toast.success(`${data.updated} scan${data.updated === 1 ? "" : "s"} updated`);
      setCustomer(null); setNum(""); setNote("");
      onSaved();
    } catch (err) { toast.error(formatError(err)); }
    setBusy(false);
  };

  const close = () => { setCustomer(null); setNum(""); setNote(""); onClose(); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md bg-card" data-testid="scan-bulk-edit-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Edit {ids.length} scan{ids.length === 1 ? "" : "s"}</DialogTitle>
          <DialogDescription>Only the fields you fill in are changed. Choosing a customer files the scans into their folder.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Customer</Label>
            <Picker onPick={setCustomer} testId="bulk-edit-customer" label={customer ? customer.name : "Keep current customer"} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="bulk-num">Invoice #</Label>
            <Input id="bulk-num" value={num} onChange={(e) => setNum(e.target.value)} placeholder="Keep current" maxLength={40} data-testid="bulk-edit-invoice" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="bulk-note">Note</Label>
            <Input id="bulk-note" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Keep current" maxLength={500} data-testid="bulk-edit-note" />
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={close} data-testid="bulk-edit-cancel">Cancel</Button>
            <Button type="submit" disabled={busy} data-testid="bulk-edit-save">{busy && <Loader2 size={15} className="animate-spin" />} Save changes</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
